module.exports = __webpack_public_path__ + "img/x-ray2.b5fe6dab.jpg";